export class MockChangeDetectorRef {
  detectChanges = jasmine.createSpy('detectChanges');
  markForCheck = jasmine.createSpy('markForCheck');
  detach = jasmine.createSpy('detach');
  checkNoChanges = jasmine.createSpy('checkNoChanges');
  reattach = jasmine.createSpy('reattach');
}
